import React from 'react';
import clsx from 'clsx';
import { Table } from 'semantic-ui-react';
import {
  columnMultiSelect,
  columnName,
  columnRole,
  columnReason,
  columnValidFrom,
  columnValidTo,
  columnActive,
  columnTools,
  columnRoleLink,
  columnCreatedBy,
  columnCreatedByLink,
  columnIpAddress,
  hasColumn,
} from '@/constants/fields';
import { roleUrl, userUrl } from '@/constants/urls';
import SimpleCell from '@/components/table/SimpleCell';
import ToggleCell from '@/components/table/ToggleCell';
import MarkdownCell from '@/components/table/MarkdownCell';
import NameCell from '@/components/table/NameCell';
import SelectableRow from '@/components/table/SelectableRow';
import TokenNameCell from './TokenNameCell';
import TokenTools from '../containers/TokenTools';

const TokenRow = ({
  category,
  token,
  onCheckBoxClick,
  showRevoke,
  upward,
  className,
  columns = [
    columnMultiSelect,
    columnName,
    columnRole,
    columnIpAddress,
    columnReason,
    columnValidFrom,
    columnValidTo,
    columnActive,
    columnTools,
  ],
}) => (
  <SelectableRow
    className={clsx('aridhia-token-row', className)}
    selected={token.selected}
    label={token.name}
    columns={columns}
    onClick={() => onCheckBoxClick(token.code, category)}
  >
    {hasColumn(columns, columnName) && (
      <TokenNameCell name={token.name} active={token.active} jwt={token.jwt} />
    )}
    {hasColumn(columns, columnValidFrom) && (<SimpleCell content={token.createdOn} disabled={!token.active} />)}
    {hasColumn(columns, columnValidTo) && (<SimpleCell content={token.expiresOn} disabled={!token.active} />)}
    {hasColumn(columns, [columnCreatedBy, columnCreatedByLink]) && (
      <NameCell
        disabled={!token.active}
        link={hasColumn(columns, columnCreatedByLink) ? userUrl(token.user) : undefined}
        name={token.user.name}
      />
    )}
    {hasColumn(columns, [columnRole, columnRoleLink]) && (
      <NameCell
        disabled={!token.active}
        link={hasColumn(columns, columnRoleLink) ? roleUrl(token.role) : undefined}
        name={token.role.name}
      />
    )}
    {hasColumn(columns, columnIpAddress) && (<MarkdownCell className="td-ip-range" value={token.ip_range} />)}
    {hasColumn(columns, columnReason) && (<MarkdownCell className="td-description" value={token.description} />)}
    {hasColumn(columns, columnActive) && (
      <ToggleCell
        checked={token.active}
        disabled={!token.active}
        label={token.name}
        onClick={() => showRevoke(category, token.code)}
      />
    )}
    {hasColumn(columns, columnTools) && (
      <Table.Cell collapsing>
        <TokenTools upward={upward} category={category} token={token} />
      </Table.Cell>
    )}
  </SelectableRow>
);

export default TokenRow;
